const a = {
  "bl-overlay-16": "blur(16px)",
  "bl-overlay-8": "blur(8px)"
}, l = {
  100: "2px",
  200: "4px",
  300: "8px",
  1e3: "999px"
}, e = {
  xs: "0px",
  sm: "375px",
  md: "768px",
  lg: "1024px",
  xl: "1440px",
  xxl: "1600px"
}, s = {
  black: "#141413",
  white: "#ffffff",
  "grey-100": "#292929",
  "grey-90": "#363636",
  "grey-80": "#494D50",
  "grey-70": "#595F64",
  "grey-60": "#6B747B",
  "grey-50": "#969DA3",
  "grey-40": "#BABFC4",
  "grey-30": "#DFE2E5",
  "grey-20": "#EBEBEB",
  "grey-10": "#F2F2F2",
  "lime-green": "#D7E600",
  "red-60": "#D71C1C",
  "red-50": "#E64040",
  "green-60": "#1B882B",
  "green-50": "#32D74B",
  orange: "#F7BF31",
  "blue-60": "#034EC8",
  "blue-50": "#417BD9",
  "red-brabus": "#E51236",
  "red-brabus-light": "#ED3252"
}, x = {
  start: "flex-start",
  center: "center",
  end: "flex-end",
  stretch: "stretch"
}, r = {
  auto: "auto",
  "min-content": "min-content",
  "max-content": "max-content",
  "fit-content": "fit-content",
  full: "100%",
  "1/2": "50%",
  "1/3": "33.333333%",
  "2/3": "66.666667%",
  "1/4": "25%",
  "2/4": "50%",
  "3/4": "75%",
  "1/5": "20%",
  "2/5": "40%",
  "3/5": "60%",
  "4/5": "80%",
  "1/6": "16.666667%",
  "2/6": "33.333333%",
  "3/6": "50%",
  "4/6": "66.666667%",
  "5/6": "83.333333%"
}, m = {
  f1: "100ms",
  f2: "150ms",
  f3: "300ms",
  n1: "500ms",
  n2: "700ms",
  s1: "900ms",
  s2: "1100ms",
  s3: "1300ms",
  s4: "1500ms"
}, i = {
  "gr-skeleton": "linear-gradient(90deg, #DFE2E5 0%, #F2F2F2 100%)",
  "gr-background": "linear-gradient(180deg, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0.25) 71.88%, rgba(0, 0, 0, 0.08) 87.5%, rgba(0, 0, 0, 0) 100%)"
}, n = {
  start: "flex-start",
  center: "center",
  end: "flex-end",
  between: "space-between",
  around: "space-around",
  evenly: "space-evenly"
}, t = {
  "ease-functional": "cubic-bezier(0.25, 0.1, 0.25, 1)",
  "ease-focus": "cubic-bezier(0.42, 0, 0.58, 1)",
  "ease-emotional": "cubic-bezier(0, 0, 0.58, 1)",
  "ease-exit": "cubic-bezier(0,42, 0, 1, 1)"
}, g = {
  horizontal: "horizontal",
  vertical: "vertical"
}, p = {
  "flat-100": "(0px 2px 2px rgba(0, 0, 0, 0.08), 0px 0px 4px rgba(0, 0, 0, 0.08))",
  "flat-200": "(0px 4px 8px rgba(0, 0, 0, 0.08), 0px 0px 8px rgba(0, 0, 0, 0.08))",
  "elevated-100": "(0px 8px 16px rgba(0, 0, 0, 0.08), 0px 0px 16px rgba(0, 0, 0, 0.08))"
}, o = {
  xxs: "4px",
  xs: "8px",
  sm: "12px",
  md: "16px",
  lg: "24px",
  xl: "32px",
  xxl: "40px",
  "3xl": "48px",
  "4xl": "64px",
  "5xl": "96px",
  "6xl": "128px"
}, d = {
  0: {
    xs: "0px",
    sm: "0px",
    md: "0px",
    lg: "0px",
    xl: "0px",
    xxl: "0px"
  },
  50: {
    xs: "4px",
    sm: "4px",
    md: "4px",
    lg: "4px",
    xl: "4px",
    xxl: "4px"
  },
  100: {
    xs: "8px",
    sm: "8px",
    md: "8px",
    lg: "8px",
    xl: "8px",
    xxl: "8px"
  },
  200: {
    xs: "12px",
    sm: "12px",
    md: "12px",
    lg: "12px",
    xl: "12px",
    xxl: "12px"
  },
  300: {
    xs: "16px",
    sm: "16px",
    md: "16px",
    lg: "16px",
    xl: "16px",
    xxl: "16px"
  },
  400: {
    xs: "24px",
    sm: "24px",
    md: "24px",
    lg: "24px",
    xl: "24px",
    xxl: "24px"
  },
  500: {
    xs: "28px",
    sm: "28px",
    md: "32px",
    lg: "36px",
    xl: "40px",
    xxl: "48px"
  },
  600: {
    xs: "36px",
    sm: "36px",
    md: "40px",
    lg: "48px",
    xl: "60px",
    xxl: "76px"
  },
  700: {
    xs: "48px",
    sm: "48px",
    md: "56px",
    lg: "64px",
    xl: "76px",
    xxl: "96px"
  },
  800: {
    xs: "64px",
    sm: "64px",
    md: "72px",
    lg: "80px",
    xl: "96px",
    xxl: "120px"
  },
  900: {
    xs: "96px",
    sm: "96px",
    md: "104px",
    lg: "120px",
    xl: "144px",
    xxl: "180px"
  },
  1e3: {
    xs: "120px",
    sm: "120px",
    md: "140px",
    lg: "168px",
    xl: "200px",
    xxl: "240px"
  }
}, c = {
  full: "12",
  "1/2": "6",
  "1/3": "4",
  "2/3": "8",
  "1/4": "3",
  "2/4": "6",
  "3/4": "9",
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  10: "10",
  11: "11",
  12: "12"
}, f = {
  100: "1px",
  200: "2px",
  300: "3px"
}, h = {
  light: {
    "bg-level-1": s.white,
    "bg-level-2": s["grey-10"],
    "bg-level-3": s["grey-20"],
    "bg-level-1-inverted": s.black,
    "bg-level-2-inverted": s["grey-90"],
    "bg-level-3-inverted": s["grey-80"],
    "bg-overlay-42": "rgba(0, 0, 0, 0.42)",
    "bg-overlay-18": "rgba(0, 0, 0, 0.18)",
    "bg-overlay-80": "rgba(0, 0, 0, 0.8)",
    "c-high-contrast": s.black,
    "c-mid-contrast": s["grey-60"],
    "c-inverted": s.white,
    "c-disabled": s["grey-40"],
    "c-hover": s["grey-50"],
    "c-pressed": s["grey-60"],
    "s-primary": s.black,
    "s-secondary": "transparent",
    "s-disabled": s["grey-10"],
    "dc-standard": s.black,
    "dc-standard-disabled": s["grey-40"],
    "dc-accent": s.black,
    "dc-accent-disabled": "#14141366",
    "ds-standard": s["grey-20"],
    "ds-standard-disabled": "#EBEBEB80",
    "ds-accent": s["lime-green"],
    "ds-accent-disabled": "#D7E60066",
    "ds-glass": "#14141399",
    "sl-hover": "#969DA31A",
    "sl-pressed": "#969DA34D",
    "sl-focused": s["blue-50"],
    "div-default": s["grey-30"],
    "sig-informational": s["grey-80"],
    "sig-success": s["green-60"],
    "sig-error": s["red-60"],
    "sig-warning": s.orange
  },
  dark: {
    "bg-level-1": s.black,
    "bg-level-2": s["grey-90"],
    "bg-level-3": s["grey-80"],
    "bg-level-1-inverted": s.white,
    "bg-level-2-inverted": s["grey-10"],
    "bg-level-3-inverted": s["grey-20"],
    "bg-overlay-42": "rgba(0, 0, 0, 0.42)",
    "bg-overlay-18": "rgba(0, 0, 0, 0.18)",
    "bg-overlay-80": "rgba(0, 0, 0, 0.8)",
    "c-high-contrast": s.white,
    "c-mid-contrast": s["grey-40"],
    "c-inverted": s.black,
    "c-disabled": s["grey-60"],
    "c-hover": s["grey-50"],
    "c-pressed": s["grey-60"],
    "s-primary": s.white,
    "s-secondary": "transparent",
    "s-disabled": s["grey-80"],
    "dc-standard": s.white,
    "dc-standard-disabled": s["grey-60"],
    "dc-accent": s.black,
    "dc-accent-disabled": "#14141366",
    "ds-glass": "#FFFFFF99",
    "ds-standard": s["grey-80"],
    "ds-standard-disabled": "#494D5080",
    "ds-accent": s["lime-green"],
    "ds-accent-disabled": "#D7E60099",
    "sl-hover": "#969DA333",
    "sl-pressed": "#969DA366",
    "sl-focused": s["blue-60"],
    "div-default": s["grey-80"],
    "sig-informational": s["grey-20"],
    "sig-success": s["green-50"],
    "sig-error": s["red-50"],
    "sig-warning": s.orange
  }
}, C = {
  "cap-100": {
    "font-family": {
      xs: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      sm: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      md: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      lg: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      xl: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      xxl: "('FOR smart Sans CC', helvetica, arial, sans-serif)"
    },
    "font-weight": {
      xs: "normal",
      sm: "normal",
      md: "normal",
      lg: "normal",
      xl: "normal",
      xxl: "normal"
    },
    "font-size": {
      xs: "16px",
      sm: "16px",
      md: "16px",
      lg: "16px",
      xl: "16px",
      xxl: "16px"
    },
    "line-height": {
      xs: "1.4",
      sm: "1.4",
      md: "1.4",
      lg: "1.4",
      xl: "1.4",
      xxl: "1.4"
    },
    "letter-spacing": {
      xs: "0em",
      sm: "0em",
      md: "0em",
      lg: "0em",
      xl: "0em",
      xxl: "0em"
    }
  },
  "cap-200": {
    "font-family": {
      xs: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      sm: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      md: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      lg: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      xl: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      xxl: "('FOR smart Sans CC', helvetica, arial, sans-serif)"
    },
    "font-weight": {
      xs: "normal",
      sm: "normal",
      md: "normal",
      lg: "normal",
      xl: "normal",
      xxl: "normal"
    },
    "font-size": {
      xs: "14px",
      sm: "14px",
      md: "14px",
      lg: "14px",
      xl: "14px",
      xxl: "14px"
    },
    "line-height": {
      xs: "1.3",
      sm: "1.3",
      md: "1.3",
      lg: "1.3",
      xl: "1.3",
      xxl: "1.3"
    },
    "letter-spacing": {
      xs: "0em",
      sm: "0em",
      md: "0em",
      lg: "0em",
      xl: "0em",
      xxl: "0em"
    }
  },
  "cap-300": {
    "font-family": {
      xs: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      sm: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      md: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      lg: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      xl: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      xxl: "('FOR smart Sans CC', helvetica, arial, sans-serif)"
    },
    "font-weight": {
      xs: "normal",
      sm: "normal",
      md: "normal",
      lg: "normal",
      xl: "normal",
      xxl: "normal"
    },
    "font-size": {
      xs: "12px",
      sm: "12px",
      md: "12px",
      lg: "12px",
      xl: "12px",
      xxl: "12px"
    },
    "line-height": {
      xs: "1.3",
      sm: "1.3",
      md: "1.3",
      lg: "1.3",
      xl: "1.3",
      xxl: "1.3"
    },
    "letter-spacing": {
      xs: "0.01em",
      sm: "0.01em",
      md: "0.01em",
      lg: "0.01em",
      xl: "0.01em",
      xxl: "0.01em"
    }
  },
  "cap-400": {
    "font-family": {
      xs: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      sm: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      md: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      lg: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      xl: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      xxl: "('FOR smart Sans CC', helvetica, arial, sans-serif)"
    },
    "font-weight": {
      xs: "normal",
      sm: "normal",
      md: "normal",
      lg: "normal",
      xl: "normal",
      xxl: "normal"
    },
    "font-size": {
      xs: "10px",
      sm: "10px",
      md: "10px",
      lg: "10px",
      xl: "10px",
      xxl: "10px"
    },
    "line-height": {
      xs: "1.3",
      sm: "1.3",
      md: "1.3",
      lg: "1.3",
      xl: "1.3",
      xxl: "1.3"
    },
    "letter-spacing": {
      xs: "0.01em",
      sm: "0.01em",
      md: "0.01em",
      lg: "0.01em",
      xl: "0.01em",
      xxl: "0.01em"
    }
  }
}, v = {
  "d-300": {
    "font-family": {
      xs: "('FOR smart Next', helvetica, arial, sans-serif)",
      sm: "('FOR smart Next', helvetica, arial, sans-serif)",
      md: "('FOR smart Next', helvetica, arial, sans-serif)",
      lg: "('FOR smart Next', helvetica, arial, sans-serif)",
      xl: "('FOR smart Next', helvetica, arial, sans-serif)",
      xxl: "('FOR smart Next', helvetica, arial, sans-serif)"
    },
    "font-weight": {
      xs: "normal",
      sm: "normal",
      md: "normal",
      lg: "normal",
      xl: "normal",
      xxl: "normal"
    },
    "font-size": {
      xs: "44px",
      sm: "44px",
      md: "48px",
      lg: "56px",
      xl: "72px",
      xxl: "80px"
    },
    "line-height": {
      xs: "1.2",
      sm: "1.2",
      md: "1.2",
      lg: "1.2",
      xl: "1.2",
      xxl: "1.2"
    },
    "letter-spacing": {
      xs: "-0.01em",
      sm: "-0.01em",
      md: "-0.01em",
      lg: "-0.01em",
      xl: "-0.01em",
      xxl: "-0.01em"
    }
  },
  "d-200": {
    "font-family": {
      xs: "('FOR smart Next', helvetica, arial, sans-serif)",
      sm: "('FOR smart Next', helvetica, arial, sans-serif)",
      md: "('FOR smart Next', helvetica, arial, sans-serif)",
      lg: "('FOR smart Next', helvetica, arial, sans-serif)",
      xl: "('FOR smart Next', helvetica, arial, sans-serif)",
      xxl: "('FOR smart Next', helvetica, arial, sans-serif)"
    },
    "font-weight": {
      xs: "normal",
      sm: "normal",
      md: "normal",
      lg: "normal",
      xl: "normal",
      xxl: "normal"
    },
    "font-size": {
      xs: "36px",
      sm: "36px",
      md: "40px",
      lg: "48px",
      xl: "48px",
      xxl: "56px"
    },
    "line-height": {
      xs: "1.2",
      sm: "1.2",
      md: "1.2",
      lg: "1.2",
      xl: "1.1",
      xxl: "1.1"
    },
    "letter-spacing": {
      xs: "-0.01em",
      sm: "-0.01em",
      md: "-0.01em",
      lg: "-0.02em",
      xl: "-0.02em",
      xxl: "-0.02em"
    }
  },
  "d-100": {
    "font-family": {
      xs: "('FOR smart Next', helvetica, arial, sans-serif)",
      sm: "('FOR smart Next', helvetica, arial, sans-serif)",
      md: "('FOR smart Next', helvetica, arial, sans-serif)",
      lg: "('FOR smart Next', helvetica, arial, sans-serif)",
      xl: "('FOR smart Next', helvetica, arial, sans-serif)",
      xxl: "('FOR smart Next', helvetica, arial, sans-serif)"
    },
    "font-weight": {
      xs: "normal",
      sm: "normal",
      md: "normal",
      lg: "normal",
      xl: "normal",
      xxl: "normal"
    },
    "font-size": {
      xs: "24px",
      sm: "24px",
      md: "24px",
      lg: "28px",
      xl: "32px",
      xxl: "40px"
    },
    "line-height": {
      xs: "1.1",
      sm: "1.1",
      md: "1.1",
      lg: "1.1",
      xl: "1.1",
      xxl: "1.1"
    },
    "letter-spacing": {
      xs: "-0.01em",
      sm: "-0.01em",
      md: "-0.01em",
      lg: "-0.02em",
      xl: "-0.02em",
      xxl: "-0.02em"
    }
  }
}, F = {
  "hl-300": {
    "font-family": {
      xs: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      sm: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      md: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      lg: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      xl: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      xxl: "('FOR smart Sans CC', helvetica, arial, sans-serif)"
    },
    "font-weight": {
      xs: "normal",
      sm: "normal",
      md: "normal",
      lg: "normal",
      xl: "normal",
      xxl: "normal"
    },
    "font-size": {
      xs: "32px",
      sm: "32px",
      md: "32px",
      lg: "36px",
      xl: "40px",
      xxl: "48px"
    },
    "line-height": {
      xs: "1.2",
      sm: "1.2",
      md: "1.2",
      lg: "1.2",
      xl: "1.2",
      xxl: "1.2"
    },
    "letter-spacing": {
      xs: "-0.02em",
      sm: "-0.02em",
      md: "-0.02em",
      lg: "-0.02em",
      xl: "-0.02em",
      xxl: "-0.02em"
    }
  },
  "hl-200": {
    "font-family": {
      xs: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      sm: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      md: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      lg: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      xl: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      xxl: "('FOR smart Sans CC', helvetica, arial, sans-serif)"
    },
    "font-weight": {
      xs: "normal",
      sm: "normal",
      md: "normal",
      lg: "normal",
      xl: "normal",
      xxl: "normal"
    },
    "font-size": {
      xs: "24px",
      sm: "24px",
      md: "24px",
      lg: "28px",
      xl: "32px",
      xxl: "40px"
    },
    "line-height": {
      xs: "normal",
      sm: "normal",
      md: "normal",
      lg: "normal",
      xl: "normal",
      xxl: "normal"
    },
    "letter-spacing": {
      xs: "-0.01em",
      sm: "-0.01em",
      md: "-0.01em",
      lg: "-0.01em",
      xl: "-0.02em",
      xxl: "-0.02em"
    }
  },
  "hl-100": {
    "font-family": {
      xs: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      sm: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      md: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      lg: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      xl: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      xxl: "('FOR smart Sans CC', helvetica, arial, sans-serif)"
    },
    "font-weight": {
      xs: "normal",
      sm: "normal",
      md: "normal",
      lg: "normal",
      xl: "normal",
      xxl: "normal"
    },
    "font-size": {
      xs: "22px",
      sm: "22px",
      md: "22px",
      lg: "24px",
      xl: "24px",
      xxl: "28px"
    },
    "line-height": {
      xs: "1.2",
      sm: "1.2",
      md: "1.2",
      lg: "1.2",
      xl: "1.2",
      xxl: "1.2"
    },
    "letter-spacing": {
      xs: "-0.01em",
      sm: "-0.01em",
      md: "-0.01em",
      lg: "-0.01em",
      xl: "-0.01em",
      xxl: "-0.01em"
    }
  },
  "hl-50": {
    "font-family": {
      xs: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      sm: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      md: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      lg: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      xl: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      xxl: "('FOR smart Sans CC', helvetica, arial, sans-serif)"
    },
    "font-weight": {
      xs: "normal",
      sm: "normal",
      md: "normal",
      lg: "normal",
      xl: "normal",
      xxl: "normal"
    },
    "font-size": {
      xs: "18px",
      sm: "18px",
      md: "18px",
      lg: "20px",
      xl: "20px",
      xxl: "24px"
    },
    "line-height": {
      xs: "1.2",
      sm: "1.2",
      md: "1.2",
      lg: "1.2",
      xl: "1.2",
      xxl: "1.2"
    },
    "letter-spacing": {
      xs: "-0.01em",
      sm: "-0.01em",
      md: "-0.01em",
      lg: "-0.01em",
      xl: "-0.01em",
      xxl: "-0.01em"
    }
  }
}, R = {
  "hyp-200": {
    "font-family": {
      xs: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      sm: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      md: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      lg: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      xl: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      xxl: "('FOR smart Sans CC', helvetica, arial, sans-serif)"
    },
    "text-decoration": {
      xs: "underline",
      sm: "underline",
      md: "underline",
      lg: "underline",
      xl: "underline",
      xxl: "underline"
    },
    "font-weight": {
      xs: "bold",
      sm: "bold",
      md: "bold",
      lg: "bold",
      xl: "bold",
      xxl: "bold"
    },
    "font-size": {
      xs: "16px",
      sm: "16px",
      md: "16px",
      lg: "16px",
      xl: "16px",
      xxl: "16px"
    },
    "line-height": {
      xs: "1.4",
      sm: "1.4",
      md: "1.4",
      lg: "1.4",
      xl: "1.4",
      xxl: "1.4"
    },
    "letter-spacing": {
      xs: "0em",
      sm: "0em",
      md: "0em",
      lg: "0em",
      xl: "0em",
      xxl: "0em"
    }
  },
  "hyp-100": {
    "font-family": {
      xs: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      sm: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      md: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      lg: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      xl: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      xxl: "('FOR smart Sans CC', helvetica, arial, sans-serif)"
    },
    "text-decoration": {
      xs: "underline",
      sm: "underline",
      md: "underline",
      lg: "underline",
      xl: "underline",
      xxl: "underline"
    },
    "font-weight": {
      xs: "bold",
      sm: "bold",
      md: "bold",
      lg: "bold",
      xl: "bold",
      xxl: "bold"
    },
    "font-size": {
      xs: "14px",
      sm: "14px",
      md: "14px",
      lg: "14px",
      xl: "14px",
      xxl: "14px"
    },
    "line-height": {
      xs: "1.4",
      sm: "1.4",
      md: "1.4",
      lg: "1.4",
      xl: "1.4",
      xxl: "1.4"
    },
    "letter-spacing": {
      xs: "0em",
      sm: "0em",
      md: "0em",
      lg: "0em",
      xl: "0em",
      xxl: "0em"
    }
  },
  "hyp-lgl": {
    "font-family": {
      xs: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      sm: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      md: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      lg: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      xl: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      xxl: "('FOR smart Sans CC', helvetica, arial, sans-serif)"
    },
    "text-decoration": {
      xs: "underline",
      sm: "underline",
      md: "underline",
      lg: "underline",
      xl: "underline",
      xxl: "underline"
    },
    "font-weight": {
      xs: "bold",
      sm: "bold",
      md: "bold",
      lg: "bold",
      xl: "bold",
      xxl: "bold"
    },
    "font-size": {
      xs: "12px",
      sm: "12px",
      md: "12px",
      lg: "12px",
      xl: "12px",
      xxl: "12px"
    },
    "line-height": {
      xs: "1.4",
      sm: "1.4",
      md: "1.4",
      lg: "1.4",
      xl: "1.4",
      xxl: "1.4"
    },
    "letter-spacing": {
      xs: "0em",
      sm: "0em",
      md: "0em",
      lg: "0em",
      xl: "0em",
      xxl: "0em"
    }
  }
}, O = {
  "lbl-200": {
    "font-family": {
      xs: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      sm: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      md: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      lg: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      xl: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      xxl: "('FOR smart Sans CC', helvetica, arial, sans-serif)"
    },
    "font-weight": {
      xs: "bold",
      sm: "bold",
      md: "bold",
      lg: "bold",
      xl: "bold",
      xxl: "bold"
    },
    "font-size": {
      xs: "16px",
      sm: "16px",
      md: "16px",
      lg: "16px",
      xl: "16px",
      xxl: "16px"
    },
    "line-height": {
      xs: "1.4",
      sm: "1.4",
      md: "1.4",
      lg: "1.4",
      xl: "1.4",
      xxl: "1.4"
    },
    "letter-spacing": {
      xs: "0em",
      sm: "0em",
      md: "0em",
      lg: "0em",
      xl: "0em",
      xxl: "0em"
    }
  },
  "lbl-100": {
    "font-family": {
      xs: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      sm: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      md: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      lg: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      xl: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      xxl: "('FOR smart Sans CC', helvetica, arial, sans-serif)"
    },
    "font-weight": {
      xs: "bold",
      sm: "bold",
      md: "bold",
      lg: "bold",
      xl: "bold",
      xxl: "bold"
    },
    "font-size": {
      xs: "14px",
      sm: "14px",
      md: "14px",
      lg: "14px",
      xl: "14px",
      xxl: "14px"
    },
    "line-height": {
      xs: "1.4",
      sm: "1.4",
      md: "1.4",
      lg: "1.4",
      xl: "1.4",
      xxl: "1.4"
    },
    "letter-spacing": {
      xs: "0.01em",
      sm: "0.01em",
      md: "0.01em",
      lg: "0.01em",
      xl: "0.01em",
      xxl: "0.01em"
    }
  }
}, b = {
  "lgl-100": {
    "font-family": {
      xs: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      sm: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      md: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      lg: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      xl: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      xxl: "('FOR smart Sans CC', helvetica, arial, sans-serif)"
    },
    "font-weight": {
      xs: "normal",
      sm: "normal",
      md: "normal",
      lg: "normal",
      xl: "normal",
      xxl: "normal"
    },
    "font-size": {
      xs: "12px",
      sm: "12px",
      md: "12px",
      lg: "12px",
      xl: "12px",
      xxl: "12px"
    },
    "line-height": {
      xs: "1.3",
      sm: "1.3",
      md: "1.3",
      lg: "1.3",
      xl: "1.3",
      xxl: "1.3"
    },
    "letter-spacing": {
      xs: "0.01em",
      sm: "0.01em",
      md: "0.01em",
      lg: "0.01em",
      xl: "0.01em",
      xxl: "0.01em"
    }
  }
}, S = {
  "link-100": {
    "font-family": {
      xs: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      sm: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      md: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      lg: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      xl: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      xxl: "('FOR smart Sans CC', helvetica, arial, sans-serif)"
    },
    "font-weight": {
      xs: "bold",
      sm: "bold",
      md: "bold",
      lg: "bold",
      xl: "bold",
      xxl: "bold"
    },
    "font-size": {
      xs: "14px",
      sm: "14px",
      md: "14px",
      lg: "14px",
      xl: "14px",
      xxl: "14px"
    },
    "line-height": {
      xs: "1.3",
      sm: "1.3",
      md: "1.3",
      lg: "1.3",
      xl: "1.3",
      xxl: "1.3"
    },
    "letter-spacing": {
      xs: "0.02em",
      sm: "0.02em",
      md: "0.02em",
      lg: "0.02em",
      xl: "0.02em",
      xxl: "0.02em"
    }
  }
}, y = {
  "p-300": {
    "font-family": {
      xs: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      sm: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      md: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      lg: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      xl: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      xxl: "('FOR smart Sans CC', helvetica, arial, sans-serif)"
    },
    "font-weight": {
      xs: "normal",
      sm: "normal",
      md: "normal",
      lg: "normal",
      xl: "normal",
      xxl: "normal"
    },
    "font-size": {
      xs: "16px",
      sm: "16px",
      md: "16px",
      lg: "18px",
      xl: "18px",
      xxl: "20px"
    },
    "line-height": {
      xs: "1.4",
      sm: "1.4",
      md: "1.4",
      lg: "1.4",
      xl: "1.4",
      xxl: "1.4"
    },
    "letter-spacing": {
      xs: "0em",
      sm: "0em",
      md: "0em",
      lg: "0em",
      xl: "0em",
      xxl: "0em"
    }
  },
  "p-200": {
    "font-family": {
      xs: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      sm: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      md: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      lg: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      xl: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      xxl: "('FOR smart Sans CC', helvetica, arial, sans-serif)"
    },
    "font-weight": {
      xs: "normal",
      sm: "normal",
      md: "normal",
      lg: "normal",
      xl: "normal",
      xxl: "normal"
    },
    "font-size": {
      xs: "16px",
      sm: "16px",
      md: "16px",
      lg: "16px",
      xl: "16px",
      xxl: "16px"
    },
    "line-height": {
      xs: "1.4",
      sm: "1.4",
      md: "1.4",
      lg: "1.4",
      xl: "1.4",
      xxl: "1.4"
    },
    "letter-spacing": {
      xs: "0em",
      sm: "0em",
      md: "0em",
      lg: "0em",
      xl: "0em",
      xxl: "0em"
    }
  },
  "p-100": {
    "font-family": {
      xs: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      sm: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      md: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      lg: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      xl: "('FOR smart Sans CC', helvetica, arial, sans-serif)",
      xxl: "('FOR smart Sans CC', helvetica, arial, sans-serif)"
    },
    "font-weight": {
      xs: "normal",
      sm: "normal",
      md: "normal",
      lg: "normal",
      xl: "normal",
      xxl: "normal"
    },
    "font-size": {
      xs: "14px",
      sm: "14px",
      md: "14px",
      lg: "14px",
      xl: "14px",
      xxl: "14px"
    },
    "line-height": {
      xs: "1.4",
      sm: "1.4",
      md: "1.4",
      lg: "1.4",
      xl: "1.4",
      xxl: "1.4"
    },
    "letter-spacing": {
      xs: "-0.01em",
      sm: "-0.01em",
      md: "-0.01em",
      lg: "-0.01em",
      xl: "-0.01em",
      xxl: "-0.01em"
    }
  }
};
export {
  a as blurs,
  l as borderRadius,
  e as breakpoints,
  C as captions,
  s as colors,
  x as crossAxisAlignments,
  r as dimensions,
  v as displays,
  m as durations,
  i as gradients,
  F as headlines,
  R as hyperlinks,
  O as labels,
  b as legal,
  S as links,
  n as mainAxisAlignments,
  t as motions,
  g as orientations,
  y as paragraphs,
  p as shadows,
  o as sizes,
  d as spacings,
  c as spans,
  f as strokes,
  h as themes
};
//# sourceMappingURL=index.mjs.map
